/* eslint-disable import/prefer-default-export */
import { rest, graphql } from 'msw';
import { faker } from '@faker-js/faker';
import { API_ORIGIN, GET_ORIGIN, WWW_ORIGIN } from '../config';
import {
  GetLoggedInUserQueryResult,
  GetLoggedInUserQueryVariables,
  UserAcceptTosMutationResult,
  UserAcceptTosMutationVariables,
  UserByIdQueryResult,
  UserByIdQueryVariables,
} from '../schema/generated/schema';
export const userID = '12345';

export const GetNewUserResponseSuccess = {
  account: '6320d40e2c6de5b688bd56c3',
  company_id: '6320d40e2c6de5b688bd56c3',
  phone_number: '',
  email_address: faker.internet.email(),
  is_onboarding: null,
  partner_tos_updated_at: '05/01/2019',
  _id: userID,
  legal: {
    general_tos: {
      accepted_date: '2022-09-13T19:03:41.884000',
    },
    privacy_policy: {
      accepted_date: '2022-09-13T19:03:41.884000',
    },
    supplies_tos: {
      accepted_date: '2022-09-13T19:03:41.884000',
    },
  },
  points: [],
  accepted_tos: true,
  first_name: '',
  last_name: '',
  privacy_policy_updated_at: '03/28/2016',
  partner_tos_accepted: false,
  privacy_policy_accepted: true,
  shipping_addresses: [] as object[],
  registration_intention: null,
  organization_id: null,
  approved_3rd_party_shipping: false,
  company_name: null,
  email_address_verified: false,
  mfa_method: '',
  shipping_accounts: [
    {
      account_number: faker.finance.accountNumber(),
      provider: 'usps',
    },
  ],
};

export const GetNewUserResponseStaffViewer = {
  ...GetNewUserResponseSuccess,
  email_address: 'Carolanne_Stoltenberg@xometry.com',
  is_logged_in_user_staff: true,
};

export const mockUser: any = {
  _id: userID,
  first_name: faker.person.firstName(),
  last_name: faker.person.lastName(),
  company_name: faker.company.name(),
  email_address: faker.internet.email(),
  phone_number: faker.phone.number('###-###-####'),
};

export const shippingAddress = {
  name: faker.person.fullName(),
  phoneNumber: faker.phone.number('###-###-####'),
  emailAddress: faker.internet.email(),
  street1: faker.location.streetAddress(),
  street2: faker.location.secondaryAddress(),
  city: faker.location.city(),
  state: faker.location.state({ abbreviated: true }),
  zipcode: faker.location.zipCode(),
  country: 'United States',
  countryCode: 'US',
  defaultIndicator: true,
};

export const userShippingAccount = () => {
  return {
    account_number: faker.finance.accountNumber(),
    provider: 'usps',
  };
};
export const buildUserShippingAccounts = () => {
  const accountList = [];
  for (let i = 0; i <= 3; i++) {
    accountList.push(userShippingAccount());
  }
  return accountList;
};

export const GetUserResponseSuccess = {
  first_name: faker.person.firstName(),
  last_name: faker.person.lastName(),
  company_name: faker.company.name(),
  phone_number: faker.phone.number('###-###-####'),
  approved_3rd_party_shipping: true,
  legal: {
    key1: '',
    key2: '',
  },
  shipping_addresses: Array(3).fill(shippingAddress),
  shipping_accounts: buildUserShippingAccounts(),
  email_address: faker.internet.email(),
  email_address_verified: true,
  mfa_method: '',
};

export const GetUserNoCompanyResponseSuccess = {
  first_name: faker.person.firstName(),
  last_name: faker.person.lastName(),
  phone_number: faker.phone.number('###-###-####'),
  approved_3rd_party_shipping: true,
  legal: {
    key1: '',
    key2: '',
  },
  shipping_addresses: Array(1).fill(shippingAddress),
  email_address: faker.internet.email(),
};

export const GetUserVendorResponseSuccess = {
  first_name: faker.person.firstName(),
  last_name: faker.person.lastName(),
  phone_number: faker.phone.number('###-###-####'),
  approved_3rd_party_shipping: true,
  legal: {
    key1: '',
    key2: '',
  },
  shipping_addresses: Array(1).fill(shippingAddress),
  email_address: faker.internet.email(),
};

const GetLoggedInUserUnregisteredSuccessResult = {
  me: {
    firstName: '',
    lastName: '',
    emailAddress: 'unregistered@gmail.com',
    partnerId: null,
    id: '3D346',
    registered: null,
  },
};
const GetLoggedInUserRegisteredSuccessResult = {
  me: {
    firstName: 'Registered',
    lastName: 'User',
    emailAddress: 'registered@gmail.com',
    partnerId: 'P1234',
    id: '3D346',
    registered: true,
  },
};

export const GetLoggedInUserUnregisteredSuccess = graphql.query<
  GetLoggedInUserQueryResult,
  GetLoggedInUserQueryVariables
>('getLoggedInUser', (_req, res, ctx) =>
  res(ctx.data(GetLoggedInUserUnregisteredSuccessResult))
);

export const GetLoggedInUserRegisteredSuccess = graphql.query<
  GetLoggedInUserQueryResult,
  GetLoggedInUserQueryVariables
>('getLoggedInUser', (_req, res, ctx) =>
  res(ctx.data(GetLoggedInUserRegisteredSuccessResult))
);

export const GetLoggedInUserInvalid = graphql.query<
  GetLoggedInUserQueryResult,
  GetLoggedInUserQueryVariables
>('getLoggedInUser', (_req, res, ctx) => res(ctx.data({ me: null })));

export const UserByIdResponseSuccess = {
  userById: {
    firstName: 'Alexa',
    lastName: 'Olson',
    emailAddress: '461f09556c26f2100aaa@d10434805db6efd58194.com',
    partnerId: 'P29731',
    id: '1F4DD',
    registered: false,
  },
};

export const UserByIdSuccessMock = graphql.query<
  UserByIdQueryResult,
  UserByIdQueryVariables
>('userById', (_req, res, ctx) => res(ctx.data(UserByIdResponseSuccess)));

export const ResetPasswordResponse = {
  statusCode: 200,
  body: {
    msg: 'johnny@test.com',
  },
};

export const GetNewUserSuccess = rest.get(
  `${API_ORIGIN}/v2/users/${userID}`,
  (req, res, ctx) => res(ctx.json(GetNewUserResponseSuccess))
);

export const GetNewUserStaffViewerSuccess = rest.get(
  `${API_ORIGIN}/v2/users/${userID}`,
  (req, res, ctx) => res(ctx.json(GetNewUserResponseStaffViewer))
);

export const GetUserSuccess = rest.get(
  `${API_ORIGIN}/v2/users/${userID}`,
  (req, res, ctx) => res(ctx.json(GetUserResponseSuccess))
);

export const GetUserNoCompanySuccess = rest.get(
  `${API_ORIGIN}/v2/users/${userID}`,
  (req, res, ctx) => res(ctx.json(GetUserNoCompanyResponseSuccess))
);

export const GetUserVendorSuccess = rest.get(
  `${API_ORIGIN}/v2/users/${userID}`,
  (req, res, ctx) => res(ctx.json(GetUserVendorResponseSuccess))
);

export const PostUserDataSuccess = rest.post(
  `${API_ORIGIN}/v2/users/${userID}/update-user-info`,
  (req, res, ctx) => res(ctx.json(GetUserResponseSuccess))
);

export const PostUserDataError = rest.post(
  `${API_ORIGIN}/v2/users/${userID}/update-user-info`,
  (req, res, ctx) => {
    return res(
      ctx.status(404),
      ctx.json({
        errorMessage: `User ${userID} not found`,
      })
    );
  }
);

export const PostUserDataNetworkError = rest.post(
  `${API_ORIGIN}/v2/users/${userID}/update-user-info`,
  (req, res) => {
    return res.networkError('Failed to connect');
  }
);

export const StaffResetPasswordSuccess = rest.get(
  `${API_ORIGIN}/v2/users/:userId/reset-password`,
  (req, res, ctx) => res(ctx.json(ResetPasswordResponse))
);

export const PostUserThirdPartyApprovedShippingSuccess = rest.post(
  `${API_ORIGIN}/v2/users/:userId/update-3rd-party-shipping`,
  (req, res, ctx) => res(ctx.json({ data: {} }))
);

export const PostUserAwardCreditsSuccess = rest.post(
  `${API_ORIGIN}/v2/users/:userId/award-credits`,
  (req, res, ctx) => res(ctx.json({ data: {} }))
);

export const PostUserAwardCreditsError = rest.post(
  `${API_ORIGIN}/v2/users/:userId/award-credits`,
  (req, res, ctx) => {
    return res(
      ctx.status(400),
      ctx.json({
        errorMessage: `User ${userID} not found`,
      })
    );
  }
);

export const PostUpdateShippingSuccess = rest.post(
  `${API_ORIGIN}/v2/users/:userId/update-shipping-address`,
  (req, res, ctx) => res(ctx.json({ data: {} }))
);

export const PostAddShippingSuccess = rest.post(
  `${API_ORIGIN}/v2/users/:userId/add-shipping-address`,
  (req, res, ctx) => res(ctx.json({ data: {} }))
);

export const PostRemoveShippingSuccess = rest.post(
  `${API_ORIGIN}/v2/users/:userId/remove-shipping-address`,
  (req, res, ctx) => res(ctx.json({ data: {} }))
);

export const RegisterBuyerSuccess = rest.post(
  `${GET_ORIGIN}/register`,
  (req, res, ctx) => {
    return res(
      ctx.json({
        redirectUrl: `${WWW_ORIGIN}/quoting/home/`,
        statusText: 'success',
        userId: '0880D',
      })
    );
  }
);

export const CompleteRegistrationBuyerSuccess = rest.post(
  `${GET_ORIGIN}/complete-registration`,
  (req, res, ctx) => {
    return res(
      ctx.json({
        redirectUrl: `${WWW_ORIGIN}/quoting/home/`,
        statusText: 'success',
        userId: '0880D',
      })
    );
  }
);

export const RegisterBuyerDuplicateError = rest.post(
  `${GET_ORIGIN}/register`,
  (req, res, ctx) => {
    return res(
      ctx.status(400),
      ctx.json({
        errors: {
          email:
            'There is already an account for this email address. Please try logging in or resetting your password.',
        },
        statusText: 'failed',
      })
    );
  }
);

export const RegisterBuyerShortPasswordError = rest.post(
  `${GET_ORIGIN}/register`,
  (req, res, ctx) => {
    return res(
      ctx.status(400),
      ctx.json({
        errors: {
          password: 'Please use at least 8 characters.',
        },
        statusText: 'failed',
      })
    );
  }
);

export const RegisterBuyerWeakPasswordError = rest.post(
  `${GET_ORIGIN}/register`,
  (req, res, ctx) => {
    return res(
      ctx.status(400),
      ctx.json({
        errors: {
          password: 'Please avoid common and easily guessable passwords.',
        },
        statusText: 'failed',
      })
    );
  }
);

export const DecodeTemporaryPasswordKeySuccess = rest.get(
  `${API_ORIGIN}/v2/users/decode-temporary-password-key/:key`,
  (req, res, ctx) =>
    res(
      ctx.json({
        id: '0880D',
        email_address: 'test@phone.com',
        has_password: false,
        is_registered: false,
      })
    )
);

export const DecodeShareTokenSuccess = rest.get(
  `${API_ORIGIN}/v2/quotes/:token/decode_shared_quote_token`,
  (req, res, ctx) =>
    res(
      ctx.json({
        sender_name: 'John Doe',
        shared_email: 'test@example.com',
        status: 200,
      })
    )
);

/* ===================================================== */
/* Example User                                          */
/* ===================================================== */
export const MockUser = {
  phone_number: '2156167789',
  accepted_tos: true,
  organization_id: '',
  company: {
    opportunities_notification_emails: ['test68@example.com'],
    account_alert_notification_emails: ['test68@example.com'],
    name: 'Extreme Metal Works',
    certifications: {},
    outsourcing_group_memberships: [
      {
        _id: '5c48c6359b1a8f00a7e1b592',
        is_member: false,
        lock: false,
        name: 'China Group',
      },
      {
        _id: '5ac2d4c39cf891008228ce89',
        is_member: false,
        lock: false,
        name: 'Ultra Premium Group',
      },
      {
        _id: '5ad3eb48b00c6b024da0f366',
        is_member: false,
        lock: false,
        name: 'Premium Group',
      },
      {
        _id: '5f64f70de549fb2a909c162b',
        is_member: false,
        lock: false,
        name: 'Default Group',
      },
    ],
    partner_id: 'P31315',
    _id: '615367668d11a00009d2d4b2',
    nda_signed: false,
    history: [
      {
        field_name: 'processes.2.status',
        field_name_formatted: 'Status: Assembly',
        value: 'Pending',
        value_formatted: 'Pending',
        updated: '2021-09-28T19:07:44.337000',
        previous_value: '',
        previous_value_formatted: '',
        staff: '25A38',
      },
      {
        field_name: 'processes.3.status',
        field_name_formatted: 'Status: CNC Machining',
        value: 'Pending',
        value_formatted: 'Pending',
        updated: '2021-09-28T19:07:44.356000',
        previous_value: '',
        previous_value_formatted: '',
        staff: '25A38',
      },
      {
        field_name: 'processes.4.status',
        field_name_formatted: 'Status: Direct Metal Laser Sintering (DMLS)',
        value: 'Pending',
        value_formatted: 'Pending',
        updated: '2021-09-28T19:07:44.374000',
        previous_value: '',
        previous_value_formatted: '',
        staff: '25A38',
      },
      {
        field_name: 'processes.6.status',
        field_name_formatted: 'Status: Selective Laser Sintering (SLS)',
        value: 'Pending',
        value_formatted: 'Pending',
        updated: '2021-09-28T19:07:44.391000',
        previous_value: '',
        previous_value_formatted: '',
        staff: '25A38',
      },
      {
        field_name: 'processes.8.status',
        field_name_formatted: 'Status: Sheet Metal',
        value: 'Pending',
        value_formatted: 'Pending',
        updated: '2021-09-28T19:07:44.409000',
        previous_value: '',
        previous_value_formatted: '',
        staff: '25A38',
      },
    ],
    completed_revenue: 0,
    partner_status: {
      status: 'registered',
      updated: '2021-09-28T19:05:10.566000',
      previous_status: 'registered',
    },
    supported_processes: [
      '543ef1f380da5b0c476373a4',
      '543ef1f380da5b0c476373a5',
      '543ef1f380da5b0c476373a6',
      '543ef1f380da5b0c476373d1',
      '5dc9d7bdcb1c6ddde2dae56d',
    ],
    has_capability_dfars_material: false,
    vendor_limits: {
      max_jobs: 1,
      max_revenue: 2500,
      manual_max_jobs: false,
      manual_max_revenue: false,
      display_jobs: true,
      display_rfqs: true,
    },
    desired_work: [],
    inspection_capabilities: [
      {
        _id: 'cmm',
        display_name: 'CMM Inspection with Dimensional Report',
      },
      {
        _id: 'fai',
        display_name: 'First Article Inspection Report (FAIR AS9102)',
        status: 'Approved',
      },
      {
        _id: 'std+r',
        display_name: 'Formal Inspection with Dimensional Report',
        status: 'Approved',
      },
    ],
    preferred_web_materials: [],
    zipcode: '90210',
    mailing_address: {
      phone_number: '2156167789',
      city: '',
      zipcode: '90210',
      street1: '',
      street2: '',
      state: '',
      country: '',
      validation_exempt: false,
    },
    has_capability_domestic_material: false,
    finish_capabilities: [],
    preferences: {
      can_skip_status_updates: {
        name: 'can_skip_status_updates',
        time: '2021-09-28T19:05:10.566000',
        value: false,
      },
      can_have_late_jobs: {
        name: 'can_have_late_jobs',
        time: '2021-09-28T19:05:10.566000',
        value: false,
      },
    },
    blind_shipping: false,
    has_imc_capability: false,
    work_status: 'Blank',
    processes: [
      {
        _id: '5cdc6d9d343133d6c5a0a4b2',
        web_name: 'Carbon Digital Light Synthesis (DLS)',
        process_type: 'additive',
      },
      {
        _id: '543ef1f380da5b0c476373a3',
        web_name: 'PolyJet',
        process_type: 'additive',
      },
      {
        _id: '5dc9d7bdcb1c6ddde2dae56d',
        web_name: 'Assembly',
        status: 'Pending',
        process_type: 'subtractive',
      },
      {
        _id: '543ef1f380da5b0c476373a6',
        web_name: 'CNC Machining',
        status: 'Pending',
        process_type: 'subtractive',
      },
      {
        _id: '543ef1f380da5b0c476373a4',
        web_name: 'Direct Metal Laser Sintering (DMLS)',
        status: 'Pending',
        process_type: 'additive',
      },
      {
        _id: '569b09bbb17bd5984508d30b',
        web_name: 'Binder Jetting',
        process_type: 'additive',
      },
      {
        _id: '543ef1f380da5b0c476373a5',
        web_name: 'Selective Laser Sintering (SLS)',
        status: 'Pending',
        process_type: 'additive',
      },
      {
        _id: '562e950ad679d34983bf0e40',
        web_name: 'Stereolithography (SLA)',
        process_type: 'additive',
      },
      {
        _id: '543ef1f380da5b0c476373d1',
        web_name: 'Sheet Metal',
        status: 'Pending',
        process_type: 'subtractive',
      },
      {
        _id: '5bbad27e0d37bc7e8d5dff72',
        web_name: 'HP Multi Jet Fusion (MJF)',
        process_type: 'additive',
      },
      {
        _id: '5a79f9631d41c81c2526ca31',
        web_name: 'Injection Molding',
        process_type: 'molding',
      },
      {
        _id: '56a01449b17bd5984508d392',
        web_name: 'Urethane Casting',
        process_type: 'molding',
      },
      {
        _id: '55771068065c1461694a4be2',
        web_name: 'Fused Deposition Modeling (FDM)',
        process_type: 'additive',
      },
    ],
    current_work_notification_emails: ['test68@example.com'],
    machines: {},
  },
  tax_exempt: false,
  points: [],
  _id: '25A38',
  alerts: [],
  last_name: 'Testerson',
  approved_3rd_party_shipping: false,
  partner_tos_accepted: true,
  shipping_addresses: [],
  privacy_policy_updated_at: '03/28/2016',
  company_name: 'Extreme Metal Works',
  email_address: 'test68@example.com',
  preferences: {},
  is_onboarding: true,
  email_address_verified: false,
  legal: {
    vendor_tos: {
      _cls: 'VendorTOS',
      accepted_date: '2021-09-28T19:05:08.470000',
    },
    general_tos: {
      _cls: 'GeneralTOS',
      accepted_date: '2021-09-28T19:05:08.470000',
    },
    privacy_policy: {
      _cls: 'PrivacyPolicy',
      accepted_date: '2021-09-28T19:05:08.470000',
    },
  },
  privacy_policy_accepted: true,
  first_name: 'Test',
  features: {},
  account: '615367648d11a00009d2d4b1',
  favorites: [],
  partner_tos_updated_at: '05/01/2019',
  credit_card_tokens: {},
};

export const MockPartnerUser = {
  isLoading: false,
  user: {
    id: '12345',
    emailAddress: 'example@example.com',
    firstName: 'Test',
    lastName: 'Testerson',
    company: {
      name: 'Integrated Technologies',
      mailing_address: {
        name: 'Integrated Technologies',
        street1: '3939 Royal Drive',
        street2: 'Suite 107',
        city: 'Kennesaw',
        state: 'GA',
        zipcode: '30144',
        country: 'US',
        phone_number: '+1 (770) 335-2840',
      },
      verified_country: 'US',
    },
  },
};

export const MockCustomerUser = {
  isLoading: false,
  user: {
    id: '12345',
    emailAddress: 'example@example.com',
    firstName: 'Test',
    lastName: 'Testerson',
  },
};
const UserAcceptTosMockResponse = {
  userAcceptTos: '12345',
};
export const UserAcceptTosMockSuccess = graphql.mutation<
  UserAcceptTosMutationResult,
  UserAcceptTosMutationVariables
>('userAcceptTos', (req, res, ctx) => res(ctx.data(UserAcceptTosMockResponse)));

export default { MockUser };
